import img1 from "./WhatsApp Image 2025-11-27 at 1.11.48 PM (1).jpeg";
import img2 from "./WhatsApp Image 2025-11-27 at 1.11.48 PM.jpeg";
import img3 from "./WhatsApp Image 2025-11-27 at 1.11.49 PM (1).jpeg";
import img4 from "./WhatsApp Image 2025-11-27 at 1.11.49 PM (2).jpeg";
import img5 from "./WhatsApp Image 2025-11-27 at 1.11.49 PM.jpeg";
import img6 from "./WhatsApp Image 2025-11-27 at 1.11.50 PM (1).jpeg";
import img7 from "./WhatsApp Image 2025-11-27 at 1.11.50 PM.jpeg";
import img8 from "./WhatsApp Image 2025-11-27 at 1.11.51 PM (1).jpeg";
import img9 from "./WhatsApp Image 2025-11-27 at 1.11.51 PM (2).jpeg";
import img10 from "./WhatsApp Image 2025-11-27 at 1.11.51 PM.jpeg";
import img11 from "./WhatsApp Image 2025-11-27 at 1.11.52 PM (1).jpeg";
import img12 from "./WhatsApp Image 2025-11-27 at 1.11.52 PM (2).jpeg";
import img13 from "./WhatsApp Image 2025-11-27 at 1.11.52 PM.jpeg";
import img14 from "./WhatsApp Image 2025-11-27 at 1.11.53 PM (1).jpeg";
import img15 from "./WhatsApp Image 2025-11-27 at 1.11.53 PM (2).jpeg";
import img16 from "./WhatsApp Image 2025-11-27 at 1.11.53 PM.jpeg";
import img17 from "./WhatsApp Image 2025-11-27 at 1.11.54 PM (1).jpeg";
import img18 from "./WhatsApp Image 2025-11-27 at 1.11.54 PM (2).jpeg";
import img19 from "./WhatsApp Image 2025-11-27 at 1.11.54 PM.jpeg";

export default [
  img1,
  img2,
  img3,
  img4,
  img5,
  img6,
  img7,
  img8,
  img9,
  img10,
  img11,
  img12,
  img13,
  img14,
  img15,
  img16,
  img17,
  img18,
  img19,
];
